import React from 'react'
import styled from 'styled-components'
import { map } from 'lodash-es'

const ImportanceHearts = ({importance}) => {
  const hearts = [0, 0, 0, 0, 0];
  const getFillRatio = (index) => {
    const importanceDecimal = importance % 1;

    if(importance - index >= 1) {
      return 100;
    } else if (importance - index > 0) {
      return importanceDecimal * 100;
    } else {
      return 0;
    }
  }

  return (
    <Hearts className="importance-hearts">
      {map(hearts, (h, index) => (
        <Heart className="heart" key={index}>
          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id={`grad-${index}-${importance*100}`}>
                <stop offset="0%" stopColor="#F17F26"/>
                <stop offset={`${getFillRatio(index)}%`} stopColor="#F17F26"/>
                <stop offset={`${getFillRatio(index)}%`} stopColor="#fff"/>
                <stop offset="100%" stopColor="#fff"/>
              </linearGradient>
            </defs>
            <path d="M1.87869 2.21194C1.60011 2.49052 1.37913 2.82124 1.22836 3.18522C1.0776 3.5492 1 3.93931 1 4.33328C1 4.72725 1.0776 5.11736 1.22836 5.48134C1.37913 5.84532 1.60011 6.17604 1.87869 6.45461L7.00003 11.5759L12.1214 6.45461C12.684 5.892 13 5.12893 13 4.33328C13 3.53762 12.684 2.77456 12.1214 2.21194C11.5587 1.64933 10.7957 1.33326 10 1.33326C9.20437 1.33326 8.44131 1.64933 7.87869 2.21194L7.00003 3.09061L6.12136 2.21194C5.84278 1.93336 5.51206 1.71238 5.14808 1.56162C4.78411 1.41085 4.39399 1.33325 4.00003 1.33325C3.60606 1.33325 3.21595 1.41085 2.85197 1.56162C2.48799 1.71238 2.15727 1.93336 1.87869 2.21194Z" stroke="#F17F26" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" fill={`url(#grad-${index}-${importance*100})`}/>
          </svg>
        </Heart>
      ))}
    </Hearts>
  )
}

export default ImportanceHearts;

const Hearts = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const Heart = styled.div`
  width: 14px;
  height: 13px;
  
  svg {
    display: block;
  }
  
  + .heart {
    margin-left: 3px;
  }
  
  @media (min-width: 340px) {
    + .heart {
      margin-left: 5px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui/importance-hearts.js